import { useSelector } from "react-redux";

// material-ui
import { Box, Typography } from "@mui/material";

// types
import { RootStateProps } from "types/root";

// project import
import NavGroup from "./NavGroup";
import { FC } from "react";
import { NavItemType } from "types/menu";

// ==============================|| DRAWER CONTENT - NAVIGATION ||============================== //

export const DrawerNavigation: FC<{
  menuItems: NavItemType[];
}> = ({ menuItems }) => {
  const menu = useSelector((state: RootStateProps) => state.menu);
  const { drawerOpen } = menu;

  const navGroups = menuItems.map((item) => {
    switch (item.type) {
      case "group":
        return <NavGroup key={item.id} item={item} />;
      default:
        return (
          <Typography key={item.id} variant="h6" color="error" align="center">
            Fix - Navigation Group
          </Typography>
        );
    }
  });

  return (
    <Box sx={{ pt: drawerOpen ? 2 : 0, "& > ul:first-of-type": { mt: 0 } }}>
      {navGroups}
    </Box>
  );
};
